/* esm.sh - applesauce-common@5.2.0/dist/models/comments */
export * from "/*applesauce-common@5.2.0/esnext/dist/models/comments.mjs";
